/* Configurable Micasa module; safe to re-render in the Shopify editor. */
window.MicasaInit.register("store-context",scope=>{
'use strict';
const tx=value=>window.MicasaText(value);


'use strict';
const stores=Object.fromEntries(window.MicasaData.stores.map(s=>[s.slug,s.short_name||s.name]));
const params=new URLSearchParams(location.search);
const read=(...keys)=>{for(const key of keys){const value=(params.get(key)||'').trim();if(value)return value.slice(0,240);}return '';};
const requestedStore=read('negozio','store');
const file=document.body.dataset.micasaPage+'.html';
const pageStore=file==='/pages/all-stores?store=cascine'?'cascine':file==='/pages/all-stores?store=pontedera'?'pontedera':'';
const selectedStore=pageStore||(stores[requestedStore]?requestedStore:'');
const product=read('prodotto','product'),department=read('reparto','department');
const normalize=value=>value.toLocaleLowerCase('it').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,' ');
const currentLabel=document.querySelector('#selected-store-name');
if(currentLabel){if(currentLabel.__micasaDefaultLabel===undefined)currentLabel.__micasaDefaultLabel=currentLabel.textContent;currentLabel.textContent=selectedStore?stores[selectedStore]:currentLabel.__micasaDefaultLabel;}

const directory=document.querySelector('#loc-directory');
if(directory){
 const cards=[...directory.querySelectorAll('[data-loc-store]')];
 const input=document.querySelector('#loc-city-input');
 const filter=document.querySelector('#loc-reparti-filter');
 const status=document.querySelector('#loc-store-status');
 const reset=document.querySelector('#loc-reset-filters');
 const cities=[...document.querySelectorAll('[data-loc-city]')];
 const empty=document.createElement('p');empty.className='loc-finder-empty';empty.hidden=true;empty.textContent=tx('Nessuna sede corrisponde alla ricerca. Prova con un’altra città oppure mostra tutte le sedi.');directory.append(empty);
 let city='all',onlyStore=stores[requestedStore]?requestedStore:'';
 if(params.get('scope')==='asian')filter.value='asian';
 const update=()=>{
  const words=normalize(input.value.trim()).split(/\s+/).filter(Boolean);
  let count=0;
  cards.forEach(card=>{
   const matchesWords=words.every(word=>normalize(card.textContent).includes(word));
   const matchesCity=city==='all'||card.dataset.locCityName===city;
   const matchesDept=filter.value==='all'||(filter.value==='bazar'&&card.dataset.locBazar==='true')||(filter.value==='asian'&&card.dataset.locAsian==='true')||(filter.value==='supermarket'&&card.dataset.locSupermarket==='true');
   const shown=matchesWords&&matchesCity&&matchesDept&&(!onlyStore||card.dataset.locStore===onlyStore);
   card.hidden=!shown;card.classList.toggle('loc-selected-store',Boolean(onlyStore&&shown));if(shown)count++;
  });
  empty.hidden=count!==0;
  const scope=filter.value==='asian'?tx(' con alimentari asiatici'):filter.value==='supermarket'?tx(' con supermercato e ristorazione'):'';
  status.textContent=count+(count===1?tx(' sede'):tx(' sedi'))+scope+(onlyStore?' · '+stores[onlyStore]:'');
  reset.hidden=!onlyStore&&!words.length&&city==='all'&&filter.value==='all';
  cities.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.locCity===city)));
 };
 const newSearch=()=>{onlyStore='';update();};
 scope.on.bind(scope,document.querySelector('#loc-search-button'))('click',newSearch);
 scope.on.bind(scope,input)('keydown',event=>{if(event.key==='Enter'){event.preventDefault();newSearch();}});
 scope.on.bind(scope,input)('input',()=>{if(!input.value.trim())newSearch();});
 scope.on.bind(scope,filter)('change',newSearch);
 cities.forEach(button=>scope.on.bind(scope,button)('click',()=>{city=button.dataset.locCity;onlyStore='';input.value='';update();}));
 scope.on.bind(scope,reset)('click',()=>{onlyStore='';city='all';input.value='';filter.value='all';update();});
 update();
}

const contact=document.querySelector('#loc-contact-form');
if(contact){
 const storeSelect=document.querySelector('#loc-contact-store');
 const topic=document.querySelector('#loc-contact-topic');
 const productInput=document.querySelector('#loc-contact-product');
 const departmentInput=document.querySelector('#loc-contact-department');
 const message=document.querySelector('#loc-contact-message');
 const disclosure=document.querySelector('#loc-form-disclosure');
 const summary=document.querySelector('#loc-context-summary');
 const contactConfig=window.MicasaSectionConfig('mc-contact-04');const placeholder=contactConfig.store_placeholder??storeSelect?.querySelector('option[value=""]')?.textContent??'';if(storeSelect){storeSelect.replaceChildren();const blank=document.createElement('option');blank.value='';blank.textContent=placeholder;storeSelect.append(blank);window.MicasaData.stores.forEach(store=>{const option=document.createElement('option');option.value=store.slug;option.textContent=store.short_name||store.name;storeSelect.append(option)});const general=document.createElement('option');general.value='general';general.textContent=contactConfig.general_label??'Informazione generale';storeSelect.append(general)}
 if(selectedStore)storeSelect.value=selectedStore;
 if(product)productInput.value=product;
 if(department)departmentInput.value=department;
 const allowedTopics=[...topic.options].map(option=>option.value).filter(Boolean);
 const requestedTopic=read('topic','argomento');
 if(allowedTopics.includes(requestedTopic))topic.value=requestedTopic;
 else if(product||department)topic.value='product';
 else if(selectedStore)topic.value='visit';
 if((product||department)&&(!message.value||message.value===message.__micasaAutofillValue)){
  const parts=[tx('Vorrei informazioni su ')+(product||tx('questo reparto'))+'.'];
  if(department)parts.push(tx('Reparto: ')+department+'.');
  if(selectedStore)parts.push(tx('Negozio: ')+stores[selectedStore]+'.');
  message.value=parts.join('\n');message.__micasaAutofillValue=message.value;
 }
 const hasContext=Boolean(selectedStore||product||department||requestedTopic);
 disclosure.open=Boolean(contact.querySelector('.micasa-form-success,.micasa-form-error'))||hasContext||!window.matchMedia('(max-width:760px)').matches;
 if(hasContext){
  summary.hidden=false;
  summary.textContent=(selectedStore?tx('Stai contattando ')+stores[selectedStore]+'. ':'')+(product?tx('Articolo: ')+product+'. ':'')+(department?tx('Reparto: ')+department+'. ':'')+(!selectedStore&&!product&&!department&&topic.value?tx('Argomento: ')+topic.options[topic.selectedIndex].text+'.':'');
 }

 const storeChannel=document.querySelector('.loc-contact-channels .loc-channel');
 if(selectedStore&&storeChannel){const base=storeChannel.__micasaStoreBase??(storeChannel.__micasaStoreBase=storeChannel.hasAttribute('href')?storeChannel.getAttribute('href'):'/pages/all-stores');if(base?.trim()){const target=new URL(base,location.href);target.searchParams.set('store',selectedStore);storeChannel.href=window.MicasaSeasonal?.url(target.href)||target.href;}else{storeChannel.setAttribute('href','');storeChannel.setAttribute('aria-disabled','true');scope.on(storeChannel,'click',e=>e.preventDefault())}}
}



});
